<template lang="html">
  <div>
    <v-dialog
      v-model="DetailAlbumsChatDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
    <v-overlay :value="progress">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-card :style="stylechat">
       <!-- modal image -->
        <div id="myModalImageAlbums" class="modalc">
            <div id="headcaption">
                <v-container>
                    <v-layout row wrap justify-center align-center>
                      <v-flex xs2 md2 sm2 style="text-align: right; padding: 10px 10px 10px 20px;">
                        <span class="close" style="cursor: pointer;font-size: 30px;" @click="closemodal()">&times;</span>
                      </v-flex>
                      <v-flex xs8 md8 sm8 style="text-align: center; padding: 10px 10px 10px 20px;">
                        <p class="mb-0 text-overflow-modal">{{image_detail.real_filename}}</p>
                        <p class="mb-0">{{date(detail_modal.timestamp)}} | {{time(detail_modal.timestamp)}}</p>
                      </v-flex>
                      <v-flex xs2 md2 sm2 style="text-align: center; padding: 10px 10px 10px 10px;">
                        <!-- <v-icon class="fz-20 color-white" @click="downloadFile(detail_modal.link, image_detail.real_filename)">fa-solid fa-download</v-icon> -->
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              color="white"
                              dark
                              v-bind="attrs"
                              v-on="on"
                              icon
                            >
                              <v-icon>fa-solid fa-ellipsis-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-item @click="downloadFile(detail_modal.link, image_detail.real_filename)">
                              <v-list-item-title>
                                <v-icon color="black" style="padding-right: 10px; font-size: 18px !important;">fa-solid fa-download</v-icon>
                                <span style="font-weight: 600;">{{ $t('AnswerQuestion.download') }}</span>
                              </v-list-item-title>
                            </v-list-item>
                            <!-- <v-list-item @click="keepFile(detail_modal.album_image_id)">
                              <v-list-item-title>
                                <v-icon color="black" style="padding-right: 10px; font-size: 18px !important;">fa-solid fa-bookmark</v-icon>
                                <span style="font-weight: 600;">{{ $t('ChatSide.RightClickMenu.keep') }}</span>
                              </v-list-item-title>
                            </v-list-item> -->
                            <v-list-item @click="openDialog(detail_modal, '', 'delete-image')">
                              <v-list-item-title>
                                <v-icon style="padding-right: 10px; font-size: 18px !important;" color="#d60000">fa-solid fa-trash-can</v-icon>
                                <span style="color: #d60000; font-weight: 600;">{{ $t('Dialog.album.btnRemoveImage') }}</span>
                              </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-flex>
                    </v-layout>
                </v-container>
            </div>
            <img class="modal-contentc" id="img01Albums">
        </div>

      <v-layout row wrap justify-center align-center class="mt-0 pl-3 pr-3">
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pl-2 pr-0 pt-0 pb-0 cursor"
          @click="close()"
        >
          <v-icon style="font-size: 30px !important;">mdi-chevron-left</v-icon>
        </v-col>
        <v-col
          v-if="album_status"
          cols="8"
          justify="center"
          align="center"
          class="pa-0 mt-2"
        >
          <p class="tab-title text-overflow mb-0">{{DetailAlbumsDialog.name !== undefined ? DetailAlbumsDialog.name : DetailAlbumsDialog.albums_name}}</p>
          <span class="tab-title-status">{{$t('ChatSide.Album.numberImage', { count: DetailAlbumsDialog.count })}}, {{date(DetailAlbumsDialog.create_date !== undefined ? DetailAlbumsDialog.create_date : DetailAlbumsDialog.timestamp)}}, {{time(DetailAlbumsDialog.create_date !== undefined ? DetailAlbumsDialog.create_date : DetailAlbumsDialog.timestamp)}}</span>
        </v-col>
        <v-col
          v-else
          cols="8"
          justify="center"
          align="center"
          class="pa-0 mt-2"
        >
          <span class="tab-title">{{$t('Dialog.album.noAlbum')}}</span>
        </v-col>
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pr-2 pl-0 pt-0 pb-0"
        >
          <v-btn v-if="album_status" color="grey" icon @click="openDialog(DetailAlbumsDialog, '', 'edit')">
            <v-icon>fa-solid fa-ellipsis-vertical</v-icon>
          </v-btn>
        </v-col>
      </v-layout>
      <v-divider v-if="!album_status" class="mt-4 mb-2"></v-divider>
      <div class="mt-8 pt-3 pl-5 pr-5 pb-2 list-overflow">
        <v-col v-if="album_status" cols="12" justify="end">
          <v-row v-if="list_albums.length == 0" class="justify-center align-center" style="height: 80vh; overflow: hidden;">
            <v-col cols="12" align="center" justify="center" class="col-no-media-not-active">
              <span>{{$t('Dialog.album.noImageAlbum')}}</span>
            </v-col>
          </v-row>
          <v-row v-else cl>
            <v-col
              v-for="(data, i) in list_albums"
              :key="i"
              class="d-flex child-flex pa-1"
              :cols="list_albums.length == 1 ? '12' : '6'"
              @click="zoom(data)"
              v-if="data.status === 'active'"
            >
              <v-img
                :src="data.link"
                :lazy-src="data.link"
                aspect-ratio="1"
                class="grey lighten-2"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-else cols="12" justify="center" align="center">
          <v-row class="justify-center align-center" style="height: 80vh;">
            <h2>{{$t('Alert.Fail.Album.removed')}}</h2>
          </v-row>
        </v-col>
      </div>
    </v-card>
    <Warning :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog"/>
    <ErrorAlert :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
    <ListBottomMenu :ListBottomMenu="ListBottomMenu" :ListBottomItem="ListBottomItem" @emitListBottom="emitListBottom" @closeAlertDialog="closeAlertDialog"/>
    <EditNameAlbums :EditAlbumsDialog="EditAlbumsDialog" :EditAlbumsDetail="EditAlbumsDetail" :AlbumsRoom="AlbumsRoom" @emitComponents="emitComponents" @closeComponents="closeComponents" />
    <AddImageAlbum :AddImageAlbumsDialog="AddImageAlbumsDialog" :AlbumsRoom="AlbumsRoom" :DetailAlbums="DetailAlbumsDialog" @emitComponents="emitComponents" @closeComponents="closeComponents" />

    <!-- <CreatedNoteChat :NoteChatDetail="NoteChatDetail" :CreatedDetailAlbumsDialog="CreatedDetailAlbumsDialog" @emitComponents="emitComponents" @closeComponents="closeComponents"/>
    <EditNoteChat :NoteDetail="NoteDetail" :EditDetailAlbumsDialog="EditDetailAlbumsDialog" @emitComponents="emitComponents" @closeComponents="closeComponents"/>
    <DetailNoteChat :NoteDetail="NoteDetail" :DetailDetailAlbumsDialog="DetailDetailAlbumsDialog" @emitComponents="emitComponents" @closeComponents="closeComponents"/> -->
  </v-dialog>
</div>
</template>

<script>
import { Momenttime } from '@/services'
import Warning from '@/components/Alert/Warning'
import ErrorAlert from '@/components/Alert/Error'
import LinkPrevue from 'link-prevue'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import { vplayer, aplayer } from 'vue-hls-player'
import ListBottomMenu from '@/components/Alert/ListBottomMenu'
import EditNameAlbums from '@/components/EditNameAlbumsChat'
import AddImageAlbum from '@/components/AddImageAlbumsChat'
// import EditNoteChat from '@/components/EditNoteChat'
// import DetailNoteChat from '@/components/DetailNoteChat'

var _ = require('lodash')
export default {
  props: {
    DetailAlbumsDialog: {},
    DetailAlbumsChatDialog: Boolean,
    AlbumsRoom: String,
    tokenuser: String
  },
  data () {
    return {
      AddImageAlbumsDialog: false,
      EditAlbumsDetail: {},
      EditAlbumsDialog: false,
      image_detail: {},
      detail_modal: {},
      date_image: '',
      progress_btm: false,
      activeKey: '',
      activeTabName: '',
      // tokenuser: '',
      tokenroom: '',
      data_user: {},
      publicPath: process.env.VUE_APP_BASE_PATH,
      NoteDetail: {},
      CreatedAlbumsDialog: false,
      ListBottomMenu: false,
      ListBottomItem: [],
      ErrorDialog: false,
      ErrorDialogDetail: {},
      WarningDialog: false,
      WarningDialogDetail: {},
      list_image: [],
      list_file: [],
      list_link: [],
      status_edit: 'start',
      limit: 20,
      offset: 0,
      access_token: '',
      refresh_token: '',
      progress: false,
      nextgetMedia: true,
      thumbnail_video: '',
      muted_video: false,
      videoOptions: {
        autoplay: true,
        controls: true,
        muted: false,
        fullscreen: true,
      },
      pageCount: 1,
      page: null,
      numPages: 1,
      urlpdf: '',
      filenamepdf: '',
      sources_video: [],
      list_albums: [],
      album_id: '',
      offset: 0,
      album_status: false,
      stylechat: {
        "--DetailAlbumsChat-HeaderColor": "white",
        "--DetailAlbumsChat-TabBackground": "white",
        "--DetailAlbumsChat-Icon": "gray",
        "--DetailAlbumsChat-HeaderPictureBorderRadius": "6px",
        "--DetailAlbumsChat-IconActive": "#2662ae",
        "--DetailAlbumsChat-Background": "white",
        "--DetailAlbumsChat-FontSize": "18px",
        "--DetailAlbumsChat-FontSize-Title": "24px",
        "--DetailAlbumsChat-FontColor": "back",
        "--DetailAlbumsChat-FontSize-Status": "16px",
        "--DetailAlbumsChat-FontColor-Status": "grey",
        "--DetailAlbumsChat-Background-Input": "#E2E1E3",
        "--DetailAlbumsChat-Color-Button": "#EFF2FE",
        "--DetailAlbumsChat-FontColor-Button": "#2662ae",
        "--DetailAlbumsChat-FontColor-Block-Button": "#cb1002",
        "--DetailAlbumsChat-FontColor-Dis-Button": "#e2e1e3",
        "--DetailAlbumsChat-Btn-Confirm-Background": "#2662ae",
        "--DetailAlbumsChat-Btn-Confirm-Color": "white",
        "--DetailAlbumsChat-Btn-Confirm-FontSize": "18px",
        "--DetailAlbumsChat-Btn-Cancel-Background": "white",
        "--DetailAlbumsChat-Btn-Cancel-Color": "#2662ae",
        "--DetailAlbumsChat-Btn-Cancel-FontSize": "18px",
        "--DetailAlbumsChat-Btn-Leave-Background": "white",
        "--DetailAlbumsChat-Btn-Leave-Color": "#ff5252",
        "--DetailAlbumsChat-Btn-Leave-FontSize": "18px",
        "--DetailAlbumsChat-FontSize-Title-Edit": "20px"
      },
    }
  },
  components: {
    ErrorAlert,
    Warning,
    LinkPrevue,
    vplayer,
    aplayer,
    VuePdfEmbed,
    ListBottomMenu,
    EditNameAlbums,
    AddImageAlbum,
    // CreatedNoteChat,
    // EditNoteChat,
    // DetailNoteChat
  },
  watch: {
    DetailAlbumsChatDialog () {
      // console.log("DetailAlbumsDialog =>", this.DetailAlbumsDialog);
      if (this.DetailAlbumsChatDialog) {
        this.tokenroom = this.AlbumsRoom
        this.album_id = this.DetailAlbumsDialog.album_id
        this.access_token = this.$cookie.get('access_token')
        this.refresh_token = this.$cookie.get('refresh_token')
        this.getAlbums()
        // var test = this.$cookie.get('language') + 'ww'
        // alert(test)
        // alert(this.$cookie.get('language') === null || this.$cookie.get('language') === 'undefined')
      }
    },
  },
  created () {
    // var user_profile = JSON.parse(this.$cookie.get('user-profile-private'))
    // this.data_user = user_profile
    // this.tokenuser = this.data_user.business_user_id
  },
  methods: {
    keepFile (id) {
      var body = {
        album_image_id: id,
      }
      this.axios.post(process.env.VUE_APP_API_PRIVATE + `/v1/keeps/save-from-album`, body, {
        headers: { Authorization: `Bearer ${this.access_token}` }
      }).then((response) => {
        if (response.data.status === 200) {
          // console.log(response.data.data)
          this.ErrorDialogDetail = {
            title: '',
            text: this.$t('Alert.Success.savekeep')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        if (err.response.data.status === 401) {
          var item = {
            type: 'keepFile',
            key: {
              album_image_id: id,
            }
          }
          this.getNewAccess(this.access_token, this.refresh_token, item)
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      })
    },
    getAlbums () {
      // if (this.offset == 0) {
      //   this.progress = true
      // }
      var body = {
        albums_id: this.album_id,
        tokenroom: this.tokenroom,
        tokenuser: this.tokenuser
      }
      this.axios.post(process.env.VUE_APP_API_EVENT + `/get_albums`, body).then((response) => {
        if (response.data.status == 'success') {
          this.progress = false
          this.album_status = response.data.data.state.status === 'active' ? true : false
          this.list_albums = response.data.data.information
          // this.offset = this.offset + 1
          this.DetailAlbumsDialog.name = response.data.data.album_name
          this.DetailAlbumsDialog.count = response.data.data.information.length
        }
      }).catch(err => {
        console.log(err.response)
        this.progress = false
        if (err.response.status === 401) {
          var data = {
            type: 'getAlbums',
            key: ''
          }
          this.getNewAccess(this.access_token, this.refresh_token, data)
        } else if (err.response.status === 400) {
          // this.ErrorDialogDetail = {
          //   title: 'Error',
          //   text: this.$t('Dialog.album.noAlbum')
          // }
          // this.ErrorDialog = true
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      })
    },
    downloadFile(file, name) {
      // console.log(file)
      // console.log(name)
      this.axios.get(file, {
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
      })
    },
    handleDocumentRender() {
      // this.isLoading = false
      this.pageCount = this.$refs.myPdfComponent.pageCount
    },
    handlePasswordRequest(callback, retry) {
      callback(prompt(retry ?
        'Enter password again' :
        'This document is password protected. Please enter a password.'
      ))
    },
    openFilePDF (file) {
      // console.log(file)
      this.detail_modal = file
      this.urlpdf = file.path
      this.filenamepdf = file.name
      var modal = document.getElementById('myModalpdf')
      modal.style.display = 'block'
    },
    zoom (item) {
      // console.log(item)
      this.detail_modal = item
      this.image_detail = item
      var modal = document.getElementById('myModalImageAlbums')
      var modalImg = document.getElementById('img01Albums')
      modal.style.display = 'block'
      modalImg.src = item.link
    },
    closemodal () {
      this.detail_modal = ''
      this.image_detail = ''
      var modal = document.getElementById('myModalImageAlbums')
      modal.style.display = 'none'
    },
    clicklink_website(url) {
      // this.checkBrowser(url, '')
      window.open(url, '_blank')
    },
    convertURL(msg) {
      var urlRegex = /\bhttps?:\/\/\S+/gi;
      var linkmsg = msg.match(urlRegex)
      if (linkmsg !== null) {
        if (linkmsg.length !== 0) {
          linkmsg.length = 1
          return linkmsg
        }
        return ''
      } else {
        return ''
      }
    },
    extension (path) {
      var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var spreadsheet = ['xls', 'xlsx', 'xlt', 'xlsm', 'xlm', 'xlsm', 'gsheet']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
      var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4']
      var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'caf']
      if (pdf.includes(extension)) {
        return 'fa-solid fa-file-pdf'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else if (media.includes(extension)) {
        return 'fa-solid fa-file-video'
      } else if (audio.includes(extension)) {
        return 'fa-solid fa-file-audio'
      } else {
        return 'fas fa-file-alt'
      }
    },
    scrollFunction () {
      // var scroll = this.$el.querySelector('#myscrollNote')
      var scroll = document.getElementById("myscrollImage")
      // console.log(scroll.scrollTop)
      if (scroll !== null && scroll !== 'null') {
        if((scroll.scrollTop + scroll.clientHeight) >= (scroll.scrollHeight * 0.6)) {
          if (this.activeKey === '1') {
            // console.log('load image')
            this.getListImage()
          } else if (this.activeKey === '2') {
            // console.log('load file')
            this.getListFile()
          } else if (this.activeKey === '3') {
            // console.log('load link')
            this.getListLink()
          }
        } else {
          if (scroll.scrollTop === 0) {
            this.offset = 0
            this.nextgetMedia = true
          }
        }
      }
    },
    emitListBottom (value) {
      // console.log(value)
      this.ListBottomMenu = false
      if (value.item.actions === 'delete-album') {
        this.openDialog(value.item, value.item.index, 'delete-album')
      } else if (value.item.actions === 'edit-album') {
        this.EditAlbumsDetail = value.item.item
        this.EditAlbumsDialog = true
      } else if (value.item.actions === 'add-image') {
        this.AddImageAlbumsDialog = true
      }
    },
    emitComponents (value) {
      // console.log(value)
      if (value.name === 'create-note') {
        this.CreatedDetailAlbumsDialog = false
        // this.getNote()
        this.list_image.unshift(value.item)
        this.list_image = _.unionBy(this.list_image, 'note_id')
        this.list_image = _.orderBy(this.list_image, 'updated_at', 'desc')
      } else if (value.name === 'detail-note') {
        this.DetailDetailAlbumsDialog = false
        // this.getNote()
      } else if (value.name === 'edit-album') {
        this.offset = 0
        this.EditAlbumsDetail = {}
        this.EditAlbumsDialog = false
        this.getAlbums()
      } else if (value.name === 'delete-album') {
        this.DetailDetailAlbumsDialog = false
        var index = _.findIndex(this.list_albums, function(o) { return o.album_id === value.item.id })
        if (index !== -1) {
          this.list_albums.splice(index, 1)
        }
      } else if (value.name === 'add-image') {
        this.AddImageAlbumsDialog = false
        this.offset = 0
        this.getAlbums()
      }
    },
    openDialog (item, index, type) {
      console.log(item)
      if (type === 'create') {
        this.CreatedDetailAlbumsDialog = true
      } else if (type === 'edit') {
        this.ListBottomItem = [
          {
            text: this.$t('Dialog.album.btnAddImage'),
            icon: 'fa-solid fa-image',
            actions: 'add-image',
            id: item.album_id,
            index: index,
            item: item
          },
          {
            text: this.$t('Dialog.album.btnEdit'),
            icon: 'fa-solid fa-pen-to-square',
            actions: 'edit-album',
            id: item.album_id,
            index: index,
            item: item
          },
          {
            text: this.$t('Dialog.album.btnRemoveAlbum'),
            icon: 'fa-solid fa-trash-can',
            actions: 'delete-album',
            id: item.album_id,
            index: index
          }
        ]
        this.ListBottomMenu = true
      } else if (type === 'delete-album') {
        this.WarningDialogDetail = {
          title: this.$t('Alert.Sure'),
          text: this.$t('Alert.Album.deleteAlbum'),
          detail: item,
          index: index,
          type: 'delete-album'
        }
        this.WarningDialog = true
      } else if (type === 'edit-album') {
        this.EditAlbumsDetail = item
        this.EditAlbumsDialog = true
      } else if (type === 'delete-image') {
        this.WarningDialogDetail = {
          title: this.$t('Alert.Sure'),
          text: this.$t('Alert.Album.deleteImage'),
          detail: item,
          index: index,
          type: 'delete-image'
        }
        this.WarningDialog = true
      }
    },
    date (timestamp) {
      if (this.$cookie.get('language') === null || this.$cookie.get('language') === 'undefined') {
        return Momenttime.dayjsdatethai(timestamp)
      } else {
        if (this.$cookie.get('language') === 'th') {
          return Momenttime.dayjsdatethai(timestamp)
        } else {
          return Momenttime.dayjsdateen(timestamp)
        }
      }
    },
    time (timestamp) {
      if (timestamp !== undefined) {
        if (this.$cookie.get('language') === 'th') {
          return Momenttime.dayjstimethai(timestamp)
        } else {
          return Momenttime.dayjstimethai(timestamp)
        }
      }
    },
    close () {
      this.offset = 0
      this.album_status = false
      this.$emit('closeComponents', {
        name: 'detail-album',
        value: false
      })
    },
    emitWarning (item) {
      // console.log(item)
      this.WarningDialog = false
      if (item.type === 'delete-album') {
        this.deleteAlbum(item.detail.id, item.index)
      } else if (item.type === 'delete-image') {
        this.deleteImageAlbum(item.detail)
      }
    },
    closeComponents (data) {
      console.log("closeComponents",data)
      if (data.name === 'create-note') {
        this.CreatedDetailAlbumsDialog = data.value
      } else if (data.name === 'edit-album') {
        this.EditAlbumsDialog = data.value
      } else if (data.name === 'detail-album') {
        this.DetailDetailAlbumsDialog = data.value
      } else if (data.name === 'add-image') {
        this.AddImageAlbumsDialog = data.value
        this.offset = 0
        this.getAlbums()
      }
    },
    closeAlertDialog (data) {
      // console.log(data)
      if (data.type === 'warning') {
        this.WarningDialog = data.value
      } else if (data.type === 'err') {
        this.ErrorDialog = data.value
      } else if (data.type === 'bottommenu') {
        this.ListBottomMenu = data.value
      }
    },
    deleteImageAlbum (item) {
      // console.log(item);
      this.closemodal()
      this.progress = true
      var body = {
        albums_id: this.album_id,
        images_id: [item.id],
        tokenroom: this.tokenroom,
        tokenuser: this.tokenuser
      }
      this.axios.post(process.env.VUE_APP_API_EVENT + `/delete_image_albums`, body).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.offset = 0
          this.getAlbums()
        } else {
          this.progress = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        if (err.response.data.status === 401) {
          var item = {
            type: 'deleteImageAlbum',
            key: item
          }
          this.getNewAccess(this.access_token, this.refresh_token, item)
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      })
    },
    deleteAlbum (id, index) {
      this.progress = true
      var body = { 
        albums_id: id,
        tokenroom: this.tokenroom,
        tokenuser: this.tokenuser
      }
      this.axios.post(process.env.VUE_APP_API_EVENT + `/delete_albums`, body).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.progress = false
          // this.list_albums.splice(index, 1)
          this.$emit('closeComponents', {
            name: 'delete-album',
            value: false
          })
          // console.log(this.list_image)
        } else {
          this.progress = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        if (err.response.data.status === 401) {
          var item = {
            type: 'deleteAlbums',
            key: {
              album_id: id,
              album_index: index
            }
          }
          this.getNewAccess(this.access_token, this.refresh_token, item)
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      })
    },
    getListImage () {
      if (this.nextgetMedia) {
        if (this.offset == 0) {
          this.progress = true
        } else {
          this.progress_btm = true
        }
        this.axios.get(process.env.VUE_APP_API_PRIVATE + `/v1/chats/${this.tokenroom}/media?limit=${this.limit}&offset=${this.offset}`, {
          headers: { Authorization: `Bearer ${this.access_token}` }
        }).then((response) => {
          if (response.data.status === 200) {
            this.progress = false
            this.progress_btm = false
            // console.log(response.data.data)
            if (response.data.data.length === 20) {
              this.nextgetMedia = true
            } else {
              this.nextgetMedia = false
            }
            this.offset = this.offset + 1

            this.list_image.push.apply(this.list_image, response.data.data)
            this.list_image = _.unionBy(this.list_image, 'message_id')
            // this.list_image = _.orderBy(this.list_image, 'updated_at', 'desc')
            // console.log(this.list_image)
            // this.date_image = response.data.data[0].timestamp
          } else {
            this.progress = false
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.progress = false
          if (err.response.data.status === 401) {
            var item = {
              type: 'getListNote',
              key: ''
            }
            this.getNewAccess(this.access_token, this.refresh_token, item)
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        })
      }
    },
    getListFile () {
      if (this.nextgetMedia) {
        if (this.offset == 0) {
          this.progress = true
        } else {
          this.progress_btm = true
        }
        this.axios.get(process.env.VUE_APP_API_PRIVATE + `/v1/chats/${this.tokenroom}/files?limit=${this.limit}&offset=${this.offset}`, {
          headers: { Authorization: `Bearer ${this.access_token}` }
        }).then((response) => {
          if (response.data.status === 200) {
            this.progress = false
            this.progress_btm = false
            // console.log(response.data.data)
            if (response.data.data.length === 20) {
              this.nextgetMedia = true
            } else {
              this.nextgetMedia = false
            }
            this.offset = this.offset + 1

            this.list_file.push.apply(this.list_file, response.data.data)
            this.list_file = _.unionBy(this.list_file, 'message_id')
            // this.list_image = _.orderBy(this.list_image, 'updated_at', 'desc')
            // console.log(this.list_file)
            // this.date_image = response.data.data[0].timestamp
          } else {
            this.progress = false
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.progress = false
          if (err.response.data.status === 401) {
            var item = {
              type: 'getListFile',
              key: ''
            }
            this.getNewAccess(this.access_token, this.refresh_token, item)
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        })
      }
    },
    getListLink () {
      if (this.nextgetMedia) {
        if (this.offset == 0) {
          this.progress = true
        } else {
          this.progress_btm = true
        }
        this.axios.get(process.env.VUE_APP_API_PRIVATE + `/v1/chats/${this.tokenroom}/links?limit=${this.limit}&offset=${this.offset}`, {
          headers: { Authorization: `Bearer ${this.access_token}` }
        }).then((response) => {
          if (response.data.status === 200) {
            this.progress = false
            this.progress_btm = false
            // console.log(response.data.data)
            if (response.data.data.length === 20) {
              this.nextgetMedia = true
            } else {
              this.nextgetMedia = false
            }
            this.offset = this.offset + 1

            this.list_link.push.apply(this.list_link, response.data.data)
            this.list_link = _.unionBy(this.list_link, 'message_id')
            // this.list_image = _.orderBy(this.list_image, 'updated_at', 'desc')
            // console.log(this.list_file)
            // this.date_image = response.data.data[0].timestamp
          } else {
            this.progress = false
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        }).catch(err => {
          console.log(err)
          this.progress = false
          if (err.response.data.status === 401) {
            var item = {
              type: 'getListLink',
              key: ''
            }
            this.getNewAccess(this.access_token, this.refresh_token, item)
          } else {
            this.ErrorDialogDetail = {
              title: 'Error',
              text: this.$t('Alert.Fail.default.somethingWrong')
            }
            this.ErrorDialog = true
          }
        })
      }
    },
    getNewAccess (oldaccess, oldrefresh, data) {
      var body = {
        access_token: oldaccess,
        refresh_token: oldrefresh
      }
      this.axios.post(process.env.VUE_APP_API_PRIVATE + `/v1/renew-access-token`, body, {
      }).then((response) => {
        if (response.data.status === 200) {
          // console.log(response.data.data)
          this.access_token = response.data.data.access_token
          this.refresh_token = response.data.data.refresh_token
          this.$cookie.set('access_token', response.data.data.access_token)
          this.$cookie.set('refresh_token', response.data.data.refresh_token)
          if (data.type === 'getAlbums') {
            this.getAlbums()
          } else if (data.type === 'deleteAlbum') {
            this.deleteAlbum(data.key.album_id, data.key.album_index)
          } else if (data.type === 'deleteImageAlbum') {
            this.deleteImageAlbum(data.key)
          } else if (data.type === 'keepFile') {
            this.keepFile(data.key.album_image_id)
          }
        }
      }).catch(err => {
        // console.log(err)
        console.log(err.response.data)
      })
    },
  }
}
</script>

<style lang="css" scoped>
.cursor {
  cursor: pointer;
}
.col-no-media-not-active {
  border-style: solid;
  border-width: thin;
  border-radius: 15px;
  background-color: #8080801c;
  border-color: #8080801c;
  height: 100px;
  align-items: center;
  justify-content: center;
  display: flex;
  /* color: #d7d7d7; */
  color: #818181;
}
.color-white {
    color: white !important;
}
.fz-20 {
  font-size: 20px !important;
}
>>>.player__controls--progress {
  flex: 1 !important;
  margin: 0 8px !important;
  z-index: 0 !important;
}
>>>.aplayer .player__controls--durration {
  color: rgb(0 0 0) !important;
}
>>>.video-js {
  display: block;
  vertical-align: top;
  box-sizing: border-box;
  color: #fff;
  background-color: #000;
  position: relative;
  padding: 0;
  font-size: 10px;
  line-height: 1;
  font-weight: 400;
  font-style: normal;
  font-family: Arial,Helvetica,sans-serif;
  word-break: initial;
  /* height: 100% !important; */
  width: 100% !important;
}
.modalc {
    display: none;
    /* Hidden by default */
    position: fixed;
    /* Stay in place */
    z-index: 1;
    /* Sit on top */
    left: 0;
    top: 0;
    width: 100vw;
    /* Full width */
    height: 100vh;
    /* Full height */
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.9);
    /* Black w/ opacity */
}

.modal-contentc {
    padding-top: 10vh;
    margin: auto;
    display: block;
    max-width: 95%;
    max-height: 80%;
}

#headcaption {
    margin: auto;
    display: block;
    text-align: left;
    color: #fff;
    padding-top: 1vh;
    padding-bottom: 1vh;
    background-color: var(--DetailAlbumsChat-HeaderPictureBorderRadius) !important;
}
.height-80vh {
  height: 80vh;
  overflow: hidden;
}
.col-no-media {
  border-style: solid;
  border-width: thin;
  border-radius: 15px;
  background-color: #8080801c;
  border-color: #8080801c;
  height: 100px;
  align-items: center;
  justify-content: center;
  display: flex;
  color: gray;
}
.text-overflow-link {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 60vw;
}
>>>.v-list-item .v-list-item__title {
  line-height: 2.0 !important;
}
.fz-19 {
  font-size: 19px;
}
.fw-600 {
  font-weight: 600;
}
.centerimg_website {
  justify-content: center;
  display: flex;
  margin-bottom: 10px;
}
.img_website {
  height: 50px;
  width: 50px;
  margin: auto;
  border-radius: 10px;
  object-fit: cover;
}
.layout-panels {
  height: calc(100vh - 140px) !important;
  /* height: 210px; */
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.layout-panels::-webkit-scrollbar {
  width: 3px;
}

.layout-panels::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}

>>>.ant-tabs-nav .ant-tabs-tab-active {
  color: var(--DetailAlbumsChat-IconActive) !important;
  text-shadow: 0 0 0.25px currentColor !important;
}
>>>.ant-tabs-ink-bar {
  position: absolute;
  bottom: 1px;
  left: 0;
  z-index: 0;
  box-sizing: border-box;
  height: 2px;
  background-color: var(--DetailAlbumsChat-IconActive) !important;
  transform-origin: 0 0;
}
.font-list-title {
  font-weight: 600;
  color: var(--DetailAlbumsChat-FontColor) !important;
}
.width-100 {
  width: 100% !important;
}
.fz-30 {
  font-size: 30px !important;
}
.fz-50 {
  font-size: 50px !important;
}
.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--DetailAlbumsChat-FontSize-Title) !important;
  color: var(--DetailAlbumsChat-FontColor) !important;
  font-weight: 600;
}
.text-title-edit {
  font-size: var(--DetailAlbumsChat-FontSize-Title-Edit) !important;
  color: var(--DetailAlbumsChat-FontColor) !important;
}
.tab-title {
  color: var(--DetailAlbumsChat-FontColor) !important;
  font-size: var(--DetailAlbumsChat-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--DetailAlbumsChat-FontColor-Status) !important;
  font-size: var(--DetailAlbumsChat-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 50vw;
}
.text-overflow-modal {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}
.checkbox-color {
  color: var(--DetailAlbumsChat-IconActive) !important;
}
>>>.v-application .elevation-10 {
  box-shadow: none !important;
}
>>>.theme--light.v-sheet {
  box-shadow: none !important;
}
.list-overflow {
  height: calc(100vh - 64px) !important;
  overflow-y: scroll;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow::-webkit-scrollbar {
  width: 3px;
}

.list-overflow::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}

.list-overflow-select {
  height: calc(100vh - 210px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow-select::-webkit-scrollbar {
  width: 3px;
}

.list-overflow-select::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}
/* >>>.v-input__slot {
  background-color: var(--DetailAlbumsChat-Background-Input) !important;
  border-radius: 10px !important;
} */
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
  background-color: var(--DetailAlbumsChat-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  /* overflow-y: auto; */
  top: 0;
  left: 0;
  overflow: hidden;
}
>>>.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.icon-color-edit {
  color: var(--DetailAlbumsChat-Icon) !important;
}
.icon-color {
  color: var(--DetailAlbumsChat-IconActive) !important;
}
.btn-confirm {
  background-color: var(--DetailAlbumsChat-Btn-Confirm-Background) !important;
  color: var(--DetailAlbumsChat-Btn-Confirm-Color) !important;
  font-size: var(--DetailAlbumsChat-Btn-Confirm-FontSize) !important;
  font-weight: 600;
}
.btn-cancel {
  background-color: var(--DetailAlbumsChat-Btn-Cancel-Background) !important;
  color: var(--DetailAlbumsChat-Btn-Cancel-Color) !important;
  font-size: var(--DetailAlbumsChat-Btn-Cancel-FontSize) !important;
  font-weight: 600;
}
.btn-leave {
  background-color: var(--DetailAlbumsChat-Btn-Leave-Background) !important;
  color: var(--DetailAlbumsChat-Btn-Leave-Color) !important;
  font-size: var(--DetailAlbumsChat-Btn-Leave-FontSize) !important;
  font-weight: 600;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
.layout-page {
  /* height: calc(100vh - 64px) !important; */
  height: 100vh !important;
  overflow: hidden !important;
  background-color: var(--DetailAlbumsChat-Background) !important;
}

.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--DetailAlbumsChat-FontSize-Title) !important;
  color: var(--DetailAlbumsChat-FontColor) !important;
  font-weight: 600;
}
.tab-title {
  color: var(--DetailAlbumsChat-FontColor) !important;
  font-size: var(--DetailAlbumsChat-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--DetailAlbumsChat-FontColor-Status) !important;
  font-size: var(--DetailAlbumsChat-FontSize-Status) !important;
}
/* .text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
} */
</style>
